export class ModalFormReset {
	static _instance;

	constructor() {
		if (ModalFormReset._instance) {
			console.warn('the ModalFormReset class is a Singleton and already has an instance');
			return ModalFormReset._instance;
		}
		ModalFormReset._instance = this;

		this.init();
	}

	init() {
		document.querySelectorAll('.js-modal').forEach((modalEl) => {
			modalEl.addEventListener('modalClose', this.handleModalClose.bind(this));
		});
	}

	handleModalClose(event) {
		const modalInstance = event.detail.modal;
		const modalContainer = modalInstance.$container;
		if (!modalContainer) return;

		const forms = modalContainer.querySelectorAll('.js-form');
		forms.forEach((form) => this.resetForm(form));
	}

	resetForm(form) {
		form.reset();

		const formInstance = window.app.classInstance.get(form)?.form;
		if (formInstance) {
			formInstance.validationEnabled = false;
			if (typeof formInstance.removeError === 'function') {
				formInstance.removeError();
			}
		}

		const elements = form.querySelectorAll('[data-type], input, textarea, select');
		elements.forEach((el) => {
			const formElement = window.app.classInstance.get(el)?.formElement;
			if (formElement && typeof formElement.reset === 'function') {
				formElement.reset();
			}
		});

		if (formInstance && typeof formInstance.formCheck === 'function') {
			formInstance.formCheck(true);
		}
	}
}
